(function () {
  'use strict';

  companyInfo.$inject = ['fileUpload', 'logoStatus'];
  angular
    .module('branding')
    .directive('companyInfo', companyInfo);

  function companyInfo(fileUpload, logoStatus) {
    var directive = {
      restrict: 'EA',
      templateUrl: 'pages/branding/template/companyInfo.html',
      transclude: true,
      require: ['ngModel', '^brandCrud'],
      replace: true,
      scope: {
        percent: '='
      },
      link: link
    };
    return directive;

    function link(scope, element, attrs, ctrls) {
      var image, item;
      var ngModel = ctrls[0];
      var crud = ctrls[1];
      var dom = angular.element('.uploadPreview');

      scope.files = [];
      scope.showPreview = false;
      scope.bgText = 'Preview logo';
      scope.uploadParams = {
        accept: ['image/png', 'image/jpg', 'image/jpeg', 'image/tiff', 'image/gif'],
        transformations: {},
        imageDim: [273, 76],
        fromSources: ['local_file_system', 'dropbox', 'box'],
        maxSize: 5 * 1024 * 1024
      };

      scope.uploadLogoButton = function () {
        fileUpload.pick(scope.uploadParams).then(scope.processLogoUpload);
      };

      scope.processLogoUpload = function (outcome) {
        if (!outcome.success) {
          return;
        }

        if (!item) {
          item = angular.element('<div class=\'logo-container\'></div>').prependTo(dom);
        }
        if (!image) {
          image = angular.element(new Image()).appendTo(item);
        }

        scope.company.logoStatus = logoStatus.replaced;
        scope.company.logoUrl = outcome.data.fileUrl;
        scope.showPreview = true;

        image.prop('src', outcome.data.fileUrl);
        scope.company.logoFileName = outcome.data.fileName;
        scope.company.logoFileId = ngModel.$modelValue.logoFileId;
      };

      scope.deleteLogo = function () {
        scope.company.logoStatus = logoStatus.removed;
        scope.showPreview = false;
        scope.company.logoUrl = '';
        scope.company.logoFileName = '';
        scope.bgText = 'Preview logo';
        if (image) {
          image.prop('src', '');
        }
      };

      scope.$watch(function () {
        return ngModel.$modelValue;
      }, function (modelValue) {
        if (scope.company === modelValue) {
          return;
        }

        scope.company = modelValue;
      });

      scope.$watch('company', function (newValue, oldValue) {
        if (newValue === null || newValue === undefined) {
          return;
        }

        ngModel.$setViewValue(newValue);

        if (crud.resetting || angular.equals(newValue, oldValue)) {
          scope.showPreview = false;
          ngModel.$setPristine();
          scope.bgText = 'Preview logo';
        } else {
          ngModel.$setDirty();
        }

        crud.setDirty(ngModel.$dirty);
      }, true);

      scope.$on('$destroy', function () {
        if (scope.uploader) {
          scope.uploader.destroy();
        }
      });
    }
  }
})();
